module.exports = __webpack_public_path__ + "media/images/favicons/apple-touch-icon-7b00f321a2b6db903e61c5d092498d7c.png";